module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Título":"Título","Autor":"Autor","Editor":"Editor","Código":"Código","Año":"Año","Situación":"Situación","Comentario":"Comentario","Escribe tu comentario":"Escribe tu comentario"},"ca":{"Título":"Títol","Autor":"Autor","Editor":"Editor","Código":"Codi","Año":"Any","Situación":"Situació","Comentario":"Comentari","Escribe tu comentario":"Escriu el teu comentari"}}')
  delete Component.options._Ctor
}
